import React, { useEffect, useState } from "react";
import BodyWrapper from "../../../components/Wrapper/BodyWrapper";
import Header from "../../../components/Header/Header";
import { useDispatch, useSelector } from "react-redux";
import { fetchInvestor } from "../../../store/Slices/InvestorSlice";
import { InvestorColumns } from "../../../assets/Columns/InvestorColumns";
import SearchableTable from "../../../components/Tables/SearchableTable";
import FetchingLoading from "../../../components/Loaders/FetchingLoading";
import CustomBtn from "../../../components/Buttons/CustomBtn";
import CreateInvestorModal from "../../../components/Modals/CreateInvestorModal";
import EditInvestorModal from "../../../components/Modals/EditInvestorModal";
import DeleteModal from "../../../components/Modals/DeleteModal";
import { DeleteInvestorApi } from "../../../ApiRequests";
import { ErrorToast, SuccessToast } from "../../../utils/ShowToast";
import AddInvestmentModal from "../../../components/Modals/AddInvestmentModal";

const Investors = () => {
  const [SearchText, setSearchText] = useState("");
  const [Loading, setLoading] = useState(false);
  const [OpenEditModal, setOpenEditModal] = useState(false);
  const [OpenDeleteModal, setOpenDeleteModal] = useState(false);
  const [Selected, setSelected] = useState(null);
  const [OpenCreateModal, setOpenCreateModal] = useState(false);
  const [OpenInvestmentModal, setOpenInvestmentModal] = useState(false);

  const dispatch = useDispatch();
  const InvestorState = useSelector((state) => state.Investors);
  useEffect(() => {
    dispatch(fetchInvestor());
  }, []);
  return (
    <BodyWrapper>
      <Header title="Investors" desc="Overview of your investors">
        <CustomBtn
          title={"Create New"}
          onClick={() => {
            setOpenCreateModal(true);
          }}
        />
        {InvestorState.data.length > 0 && (
          <CustomBtn
            title={"Add Investment"}
            onClick={() => {
              setOpenInvestmentModal(true);
            }}
          />
        )}
      </Header>
      <div className="w-full mt-10 flex justify-center items-center">
        {InvestorState.loading ? (
          <div className="flex flex-1 justify-center items-center">
            <FetchingLoading />
          </div>
        ) : (
          InvestorState.data.length !== 0 && (
            <SearchableTable
              setOpenEditModal={setOpenEditModal}
              setOpenDeleteModal={setOpenDeleteModal}
              setSelected={setSelected}
              SearchPlaceholder={"Search Investor Name..."}
              SearchText={SearchText}
              setSearchText={setSearchText}
              CurrentData={InvestorState.data}
              //   CurrentData={CategoryState.data.filter((dt) =>
              //     SearchText === ""
              //       ? true
              //       : dt.title.toLowerCase().startsWith(SearchText.toLowerCase())
              //   )}
              Columns={InvestorColumns}
            />
          )
        )}
      </div>
      {OpenCreateModal && (
        <CreateInvestorModal
          Open={OpenCreateModal}
          setOpen={setOpenCreateModal}
        />
      )}
      {OpenInvestmentModal && (
        <AddInvestmentModal
          Open={OpenInvestmentModal}
          setOpen={setOpenInvestmentModal}
        />
      )}
      {OpenEditModal && (
        <EditInvestorModal
          Open={OpenEditModal}
          setOpen={setOpenEditModal}
          currentInvestor={Selected}
        />
      )}
      {OpenDeleteModal && (
        <DeleteModal
          Open={OpenDeleteModal}
          setOpen={setOpenDeleteModal}
          Loading={Loading}
          onSubmit={async () => {
            setLoading(true);
            try {
              const response = await DeleteInvestorApi(Selected._id);
              if (response.data.success) {
                setOpenDeleteModal(false);
                SuccessToast("Investor delete successfully");
                dispatch(fetchInvestor());
              } else {
                ErrorToast(response.data.error?.msg);
              }
            } catch (err) {
              console.log(err);
              ErrorToast("Failed to delete customer!");
            }
            setLoading(false);
          }}
        />
      )}
    </BodyWrapper>
  );
};

export default Investors;
